import React from "react";
import Slider from "react-slick";
import { carouselConfigMobile, carouselConfigWeb } from "@stadium/constants";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

const ImageSliderWithMultipleRows = ({ doc }) => {
  const { header, description, link_text, link, bg_color } = doc?.primary || {};
  const style = { backgroundColor: bg_color };

  const responseSliderSettings = [
    {
      breakpoint: 767,
      settings: {
        ...carouselConfigMobile,
        slidesToShow: 2,
        slidesToScroll: 1,
        touchMove: true,
        swipeToSlide: true,
        autoplay: true,
        arrows: false,
      },
    },
  ];

  const carouselConfig = {
    ...carouselConfigWeb,
    className: "center",
    centerPadding: "60px",
    slidesToShow: 4,
    slidesToScroll: 1,
    rows: 2,
    slidesPerRow: 1,
    arrows: true,
    responsive: responseSliderSettings,
  };

  return (
    <div className="py-5 py-2xl-5 multiple-rows-slider-slice prismic-slice" style={style}>
      <div className="container container-width">
        <div className="multiple-rows-slider-header">
          {checkContentPresence(header) && (
            <div className="text-center sns-h2 multiple-rows-slider-title same-size-title">
              {textResolver(header)}
            </div>
          )}
          {checkContentPresence(description) && (
            <div className="mt-3 mt-2xl-3 text-center sns-h5 multiple-rows-slider-description">
              {textResolver(description)}
            </div>
          )}
          {checkContentPresence(link_text) && (
            <div className="d-block text-center mt-2 mt-2xl-2 multiple-rows-slider-link-row text-uppercase">
              <PrismicLinkTag
                url={link?.url}
                urlText={link_text}
                target="_blank"
                className="multiple-rows-slider-header-link"
              />
            </div>
          )}
        </div>
      </div>
      <div className="mt-5 mt-2xl-5 container container-width multiple-rows-slider-section">
        <Slider {...carouselConfig}>
          {doc?.items?.map(({ image: { alt, url }, bg_color }, index) => {
            const imageStyle = { backgroundColor: bg_color };
            return (
              url && (
                <>
                  <div
                    className="p-3 text-center multiple-row-slider-img-holder"
                    style={imageStyle}
                    key={`image-${index}`}
                  >
                    <PrismicImgix
                      alt={alt}
                      src={url}
                      className="multiple-row-slider-img"
                      desktop="300px"
                      mobile="360px"
                      tablet="275px"
                      largeDisplay="650px"
                    />
                  </div>
                </>
              )
            );
          })}
        </Slider>
      </div>
    </div>
  );
};
export default ImageSliderWithMultipleRows;
